/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState, useEffect } from "react";
import "../css/integration.css";
import { Link as RoterLink } from "react-router-dom";
import { DiscountsMinor, ProfileMinor } from "@shopify/polaris-icons";
import {
	Card,
	Banner,
	Badge,
	DisplayText,
	Button,
	Modal,
	TextField,
} from "@shopify/polaris";
import { Row, Col, Progress } from "reactstrap";
import config from "../config/config";

import { useDispatch, useSelector } from "react-redux";
import BannerWoo from "./Dashboard/BannerWoo";
import PlanTableNew from "./Dashboard/PlanTableNew";
import { useCallback } from "react";
import Swal from "sweetalert2";
import callApi from "../utils/apiCaller";
import YearlyBannerOnly from "./feature/yearly/YearlyBannerOnly";
import YearlyHaftEnhance from "./feature/yearly/YearlyHaftEnhance";

const Account = () => {
	const [limitOrder, setLimitOrder] = useState(30);
	const [discountCode, setDiscountCode] = useState("");
	const [discountCodeErr, setDiscountCodeErr] = useState("");
	const [modalApplyDiscount, setModalApplyDiscount] = useState(false);
	const [planName, setPlanName] = useState("Free");
	const [avg, setavg] = useState(0);
	const dataSettings = useSelector((state) => state.dataSettings);
	const listPayPalAccounts = useSelector((state) => state.listPayPalAccounts);

	useEffect(() => {
		switch (dataSettings.plan) {
			case "free":
				setPlanName("Free");
				break;
			case "basic":
				setPlanName("Basic");
				break;
			case "pro":
				setPlanName("Pro");
				break;
			case "pro_plus":
				setPlanName("Pro Plus");
				break;
			case "unlimited":
				setPlanName("Unlimited");
				break;
			default:
				setPlanName("Free");
		}
	}, [dataSettings]);

	useEffect(() => {
		if (dataSettings.plan !== "unlimited") {
			setavg(Math.round((dataSettings.usage / dataSettings.quota) * 100));
		}
	}, [dataSettings]);

	const applyDiscountCode = () => {
		if (discountCode == "") {
			setDiscountCodeErr("You have not entered the discount code");
		} else {
			setDiscountCodeErr("");
			let params = {
				action: "applyDiscountCode",
				discountCode: discountCode,
			};
			callApi("get", params).then(async (res) => {
				if (res.data.state == 0) {
					setDiscountCodeErr(res.data.msg);
				} else {
					setModalApplyDiscount(false);
					Swal.fire({
						icon: "success",
						title: "Successfully",
						text: res.data.msg,
						showCloseButton: false,
						showConfirmButton: false,
						timer: 5000,
					});
				}
			});
		}
	};

	const bannerMarkup = (
		<div className="intergration-page-banner">
			{/* <h2>Pricing Table</h2> */}
			<Banner
				icon={ProfileMinor}
				status={
					avg < 70 || dataSettings.plan == "unlimited"
						? "success"
						: avg < 85
						? "warning"
						: "critical"
				}
				title={"Your Plan: " + planName}
			>
				<ul
					className="p-0 font-weight-bold account-progress"
					style={{ lineHeight: "32px" }}
				>
					<li></li>
					<li>
						- Used this month: {dataSettings.usage}/
						{dataSettings.quota} orders{" "}
						{avg > 80
							? "(Once the plan limit is exceeded, subsequent orders will not be synced)"
							: ""}
					</li>
					{dataSettings.plan !== "unlimited" ? (
						<li>
							- Remaining quota:{" "}
							{dataSettings.quota - dataSettings.usage} orders
							{avg > 80
								? "(Once the plan limit is exceeded, subsequent orders will not be synced)"
								: ""}
						</li>
					) : null}

					<li>
						- PayPal Account:{" "}
						<Badge
							status={
								listPayPalAccounts.length === 0
									? "critical"
									: "success"
							}
							progress="complete"
						>
							<b>
								{listPayPalAccounts.length}
								{listPayPalAccounts.length > 1
									? " Accounts"
									: " Account"}{" "}
								Connected
							</b>
						</Badge>
						{listPayPalAccounts.length === 0 ? (
							<RoterLink
								className="ml-2"
								to={{
									pathname: config.pathName + "/settings",
									search: "?" + config.urlParamsValue,
								}}
							>
								Connect Now!
							</RoterLink>
						) : null}
					</li>
					{dataSettings.sync_stripe == "1" ? (
						<li>
							- Stripe Token:{" "}
							<Badge
								status={
									parseInt(dataSettings.stripe_token) === 0
										? "critical"
										: "success"
								}
								progress="complete"
							>
								<b>
									{parseInt(dataSettings.stripe_token)}
									{parseInt(dataSettings.stripe_token) > 1
										? " Tokens"
										: " Token"}{" "}
									Connected
								</b>
							</Badge>
							{listPayPalAccounts.length === 0 ? (
								<RoterLink
									className="ml-2"
									to={{
										pathname: config.pathName + "/settings",
										search: "?" + config.urlParamsValue,
									}}
								>
									Connect Now!
								</RoterLink>
							) : null}
						</li>
					) : (
						""
					)}
					{dataSettings.plan !== "unlimited" ? (
						<li className="mt-3">
							<Progress
								animated
								color={
									avg < 70
										? "success"
										: avg < 85
										? "warning"
										: "danger"
								}
								value={avg}
								max="100"
							>
								{" "}
								{avg}%
							</Progress>
						</li>
					) : null}
				</ul>
				{dataSettings.discount &&
				parseInt(dataSettings.discount) > 0 ? (
					<Banner
						icon={DiscountsMinor}
						title={
							"You are being applied " +
							dataSettings.discount +
							"% discount code for all monthly plans when upgrading"
						}
						status="info"
					>
						{" "}
					</Banner>
				) : (
					<Banner
						icon={DiscountsMinor}
						title="Do you have a discount code?"
						status="info"
					>
						<div className="mt-3">
							<Button onClick={() => setModalApplyDiscount(true)}>
								Apply discount code
							</Button>
						</div>
					</Banner>
				)}
			</Banner>
		</div>
	);

	const changeDiscountCode = useCallback((newValue) => {
		setDiscountCode(newValue);
		setDiscountCodeErr("");
	}, []);

	return (
		<div style={{ marginTop: "10px" }} className="integration-page">
			<div>
				<BannerWoo />
			</div>

			<Card sectioned>
				{dataSettings.plan != "pro_plus" &&
				dataSettings.plan != "unlimited" &&
				config.platform != "WOO_COMMERCE" ? (
					<Row>
						<Col lg={12}>{bannerMarkup}</Col>
						{/* <Col lg={7}> 
							<YearlyBannerOnly />
						</Col> */}
					</Row>
				) : (
					bannerMarkup
				)}
			</Card>

			{/* <Card sectioned>{bannerMarkup}</Card> */}
			<Row className="mt-5">
				<Col>
					<Card sectioned>
						<div className="mt-5 text-center">
							<DisplayText size="large">
								Pricing Table
							</DisplayText>
							<PlanTableNew />
						</div>
					</Card>
				</Col>
			</Row>
			<Modal
				open={modalApplyDiscount}
				onClose={() => setModalApplyDiscount(false)}
				title="Apply discount code"
				primaryAction={{
					content: "Apply",
					onAction: applyDiscountCode,
					disabled: discountCodeErr == "" ? false : true,
				}}
			>
				<Modal.Section>
					<TextField
						label="Discount code:"
						value={discountCode}
						onChange={changeDiscountCode}
						error={discountCodeErr}
					/>
				</Modal.Section>
			</Modal>
		</div>
	);
};

export default Account;
